import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"64px","min-height":"64px"}
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["fill", "stroke"]
const _hoisted_6 = ["fill", "stroke"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["fill", "stroke"]
const _hoisted_10 = ["fill", "stroke"]
const _hoisted_11 = ["fill", "stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = ["stroke"]
const _hoisted_16 = ["stroke"]
const _hoisted_17 = ["fill", "stroke"]
const _hoisted_18 = ["stroke"]
const _hoisted_19 = ["stroke"]
const _hoisted_20 = ["stroke"]
const _hoisted_21 = ["fill"]
const _hoisted_22 = ["fill"]
const _hoisted_23 = ["fill"]
const _hoisted_24 = ["stroke"]
const _hoisted_25 = ["stroke"]
const _hoisted_26 = ["stroke"]
const _hoisted_27 = ["fill", "stroke"]
const _hoisted_28 = ["fill", "stroke"]
const _hoisted_29 = ["fill", "stroke"]
const _hoisted_30 = ["fill", "stroke"]
const _hoisted_31 = ["fill", "stroke"]
const _hoisted_32 = ["fill", "stroke"]
const _hoisted_33 = ["fill", "stroke"]
const _hoisted_34 = ["fill", "stroke"]
const _hoisted_35 = ["fill", "stroke"]
const _hoisted_36 = ["fill", "stroke"]
const _hoisted_37 = ["fill", "stroke"]
const _hoisted_38 = ["fill", "stroke"]
const _hoisted_39 = ["fill", "stroke"]
const _hoisted_40 = ["stroke"]
const _hoisted_41 = ["stroke"]
const _hoisted_42 = ["fill", "stroke"]
const _hoisted_43 = ["stroke"]
const _hoisted_44 = ["stroke"]
const _hoisted_45 = ["stroke"]
const _hoisted_46 = ["fill", "stroke"]
const _hoisted_47 = ["fill", "stroke"]
const _hoisted_48 = ["fill", "stroke"]
const _hoisted_49 = ["fill", "stroke"]
const _hoisted_50 = ["stroke"]
const _hoisted_51 = ["stroke"]
const _hoisted_52 = ["stroke"]
const _hoisted_53 = ["stroke"]
const _hoisted_54 = ["stroke"]
const _hoisted_55 = ["stroke"]
const _hoisted_56 = ["stroke"]
const _hoisted_57 = ["fill", "stroke"]
const _hoisted_58 = ["fill"]
const _hoisted_59 = ["stroke"]
const _hoisted_60 = ["fill"]
const _hoisted_61 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'HotelSmall',
  props: {
    stroke: {
      type: String,
      required: true,
    },
    fill: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M0 8C0 3.58172 3.58172 0 8 0H56C60.4183 0 64 3.58172 64 8V56C64 60.4183 60.4183 64 56 64H8C3.58172 64 0 60.4183 0 56V8Z",
      fill: __props.fill
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M50.6965 36.4971V43.6343L22.4517 55.7114L11.1851 50.8999V43.7628",
      fill: __props.fill
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M50.6965 36.4971V43.6343L22.4517 55.7114L11.1851 50.8999V43.7628",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M52.6253 37.3217L39.4294 31.6865L10 44.2693V45.5986L23.1768 51.2253L52.6253 38.651V37.3217Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M49.0631 16.9058L46.2771 12.4651L47.9123 11.751L50.6962 16.1917V36.4973L49.0631 37.2114V16.9058Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M50.6961 16.1924L49.063 16.9065L50.6961 16.1924Z",
      fill: __props.fill
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M50.6961 16.1924L49.063 16.9065",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M36.777 22.1516L33.9932 17.7109L39.8951 15.1914L42.679 19.6321L36.777 22.1516Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M35.1101 17.2345L37.0457 20.3101L40.3796 18.8881V16.6509L38.4397 15.8125L35.1101 17.2345Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M46.184 15.0671L42.6788 14.9323L39.658 13.6431L39.345 13.5693L39.658 15.0671L39.895 15.1914L42.6788 19.6322L36.7769 22.1517V42.4572L42.6788 39.9377L46.184 40.0726L49.3762 38.7096V13.7042L46.184 15.0671Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M42.6788 24.2666L36.7769 26.7882",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M49.3761 23.034L46.1839 24.397L42.6787 24.2642V20.7799L46.1839 20.9147L49.3761 19.5518",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M42.6787 18.5304V15.1914",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M46.1841 18.6628V15.3428",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_15),
    _createElementVNode("path", {
      d: "M46.1841 24.3973V20.915",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_16),
    _createElementVNode("path", {
      d: "M37.0501 18.0734L40.3797 16.6515L38.4399 15.813L39.7683 15.2442L39.6605 15.0673L39.3474 13.5695L47.9147 11.7515L42.218 9.31836L13.9689 21.3955L11.1851 28.0882V43.7635L22.4517 48.575L30.395 45.1834L33.9002 45.3182L37.0924 43.9552V18.9498L33.9002 20.3127L30.395 20.1779L29.2823 19.7229L35.1124 17.2329L37.0522 18.0713L37.0501 18.0734Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_17),
    _createElementVNode("path", {
      d: "M28.3682 22.9103L30.3947 23.7762L33.8999 23.9089L37.09 22.5459",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_18),
    _createElementVNode("path", {
      d: "M37.0903 28.2795L33.9002 29.6424L30.395 29.5097V26.0254",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_19),
    _createElementVNode("path", {
      d: "M29.1636 25.5015L30.3947 26.026L33.9 26.1608L37.09 24.7979",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_20),
    _createElementVNode("path", {
      d: "M38.3496 28.2236L40.9824 27.0938V30.9763L38.3496 32.106V28.2236Z",
      fill: __props.fill
    }, null, 8, _hoisted_21),
    _createElementVNode("path", {
      d: "M38.3496 35.5608L40.9824 34.431V38.3135L38.3496 39.4432V35.5608Z",
      fill: __props.fill
    }, null, 8, _hoisted_22),
    _createElementVNode("path", {
      d: "M38.3496 22.8241L40.9824 21.6943V24.9891L38.3496 26.1189V22.8241Z",
      fill: __props.fill
    }, null, 8, _hoisted_23),
    _createElementVNode("path", {
      d: "M38.3496 28.2236L40.9824 27.0938V30.9763L38.3496 32.106V28.2236Z",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_24),
    _createElementVNode("path", {
      d: "M38.3496 35.5608L40.9824 34.431V38.3135L38.3496 39.4432V35.5608Z",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_25),
    _createElementVNode("path", {
      d: "M38.3496 22.8241L40.9824 21.6943V24.9891L38.3496 26.1189V22.8241Z",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_26),
    _createElementVNode("path", {
      d: "M18.2733 33.2177L15.3604 31.9854V35.8657L18.2733 37.0981V33.2177Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_27),
    _createElementVNode("path", {
      d: "M18.2733 40.5546L15.3604 39.3223V43.2026L18.2733 44.435V40.5546Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_28),
    _createElementVNode("path", {
      d: "M17.8378 25.9895L15.7986 25.1279V30.0658L17.8378 30.9295V25.9895Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_29),
    _createElementVNode("path", {
      d: "M24.9922 33.712L27.9051 32.4775V36.36L24.9922 37.5924V33.712Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_30),
    _createElementVNode("path", {
      d: "M24.9919 41.0499L27.9048 39.8154V43.6979L24.9919 44.9303V41.0499Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_31),
    _createElementVNode("path", {
      d: "M33.8684 31.8572L35.8615 30.9932V34.8735L33.8684 35.7375V31.8572Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_32),
    _createElementVNode("path", {
      d: "M46.1543 26.614L48.1474 25.75V29.6304L46.1543 30.4944V26.614Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_33),
    _createElementVNode("path", {
      d: "M33.8682 39.1941L35.8612 38.3301V42.2104L33.8682 43.0745V39.1941Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_34),
    _createElementVNode("path", {
      d: "M46.1543 33.9509L48.1474 33.0869V36.9673L46.1543 37.8313V33.9509Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_35),
    _createElementVNode("path", {
      d: "M31.1416 31.9355L32.5251 31.9882V35.8686L31.1416 35.818V31.9355Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_36),
    _createElementVNode("path", {
      d: "M31.1416 39.2725L32.5251 39.3251V43.2055L31.1416 43.1549V39.2725Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_37),
    _createElementVNode("path", {
      d: "M43.4297 26.6914L44.811 26.7441V30.6244L43.4297 30.5739V26.6914Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_38),
    _createElementVNode("path", {
      d: "M43.4297 34.0293L44.811 34.082V37.9623L43.4297 37.9118V34.0293Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_39),
    _createElementVNode("path", {
      d: "M30.395 23.7755V20.4365",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_40),
    _createElementVNode("path", {
      d: "M33.8999 23.9089V20.5889",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_41),
    _createElementVNode("path", {
      d: "M49.7317 12.1136C49.279 11.9198 48.8559 11.3573 48.5957 10.8791C48.3355 10.4009 48.0923 10.127 47.7326 10.0027L45.6067 9.0948L43.1401 9L40.8936 9.95851C40.5297 10.1397 40.2737 10.3672 39.9924 10.8327C39.6116 11.4647 39.142 11.846 38.7612 12.0462L39.1145 13.7357L42.5224 15.1913L46.4782 15.343L50.0807 13.8052L49.7317 12.1136Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_42),
    _createElementVNode("path", {
      d: "M33.8999 29.6424V26.1602",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_43),
    _createElementVNode("path", {
      d: "M42.6788 20.7809V19.6328L41.7354 18.1266L42.6788 18.531L46.184 18.6638L49.3762 17.3008",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_44),
    _createElementVNode("path", {
      d: "M11.1851 28.0898L22.4517 32.9013",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_45),
    _createElementVNode("path", {
      d: "M13.2283 31.0586V34.939L13.4938 35.0517V31.1708L13.2283 31.0586Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_46),
    _createElementVNode("path", {
      d: "M13.2283 38.3799V42.2603L13.4938 42.373V38.4921L13.2283 38.3799Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_47),
    _createElementVNode("path", {
      d: "M20.1401 34.0391V37.9194L20.4056 38.0321V34.1512L20.1401 34.0391Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_48),
    _createElementVNode("path", {
      d: "M20.1401 41.3613V45.2417L20.4056 45.3544V41.4735L20.1401 41.3613Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_49),
    _createElementVNode("path", {
      d: "M30.395 52.3167V48.1436",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_50),
    _createElementVNode("path", {
      d: "M22.4517 55.7118V50.915",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_51),
    _createElementVNode("path", {
      d: "M36.7769 45.417V49.586",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_52),
    _createElementVNode("path", {
      d: "M42.6787 42.8975V47.0622",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_53),
    _createElementVNode("path", {
      d: "M16.2891 48.2842V53.0809",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_54),
    _createElementVNode("path", {
      d: "M22.4517 48.5745V32.9014",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_55),
    _createElementVNode("path", {
      d: "M27.0586 18.8145L27.3738 20.3123L27.6086 20.4365L30.3946 29.5097L22.4513 32.9013L19.6653 23.8282L13.9685 21.395",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_56),
    _createElementVNode("path", {
      d: "M37.4456 17.3606C36.9929 17.1668 36.5698 16.6044 36.3096 16.1262C36.0494 15.648 35.8061 15.3741 35.4465 15.2498L33.3205 14.3419L30.854 14.2471L28.6074 15.2056C28.2436 15.3867 27.9876 15.6143 27.7063 16.0798C27.3255 16.7118 26.8559 17.0931 26.4751 17.2932L26.8284 18.9827L30.2363 20.4384L34.1921 20.5901L37.7946 19.0522L37.4413 17.3627L37.4456 17.3606Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_57),
    _createElementVNode("path", {
      d: "M21.9736 22.8448L23.9515 28.9434L27.2854 27.5236V22.2613L25.3033 21.4229",
      fill: __props.fill
    }, null, 8, _hoisted_58),
    _createElementVNode("path", {
      d: "M21.9736 22.8448L23.9515 28.9434L27.2854 27.5236V22.2613L25.3033 21.4229",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_59),
    _createElementVNode("path", {
      d: "M19.6655 23.8282L21.9734 22.8444L23.9577 23.6828L27.2852 22.2608L25.3031 21.4224L27.6089 20.4365",
      fill: __props.fill
    }, null, 8, _hoisted_60),
    _createElementVNode("path", {
      d: "M19.6655 23.8282L21.9734 22.8444L23.9577 23.6828L27.2852 22.2608L25.3031 21.4224L27.6089 20.4365",
      stroke: __props.stroke,
      "stroke-width": "0.8",
      "stroke-miterlimit": "10"
    }, null, 8, _hoisted_61)
  ]))
}
}

})